import {TranslateService} from '@ngx-translate/core';
import {saveAs} from 'file-saver';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {CustomDataServiceClient} from '@sharedrest/data-custom.restservice';
import {ToastService} from '@sharedcommon/services/toast.service';
import {NeqDialogService} from '@sharedcommon/services/dialog.service';
import {Injectable} from '@angular/core';

@Injectable()
export class TechnicalDocService {
  constructor(
    private readonly customRawMaterialServiceClient: CustomDataServiceClient,
    private readonly toastService: ToastService,
    private readonly translationService: TranslateService,
    private readonly neqDialogService: NeqDialogService,
  ) {
  }

  getNutrientTechnicalDoc(filename: string) {
    this.customRawMaterialServiceClient.getNutrientTechnicalDoc(filename).subscribe((data: HttpResponse<any>) => {
      this.manageSuccess(data);
    }, err => {
      this.manageError(err, filename);
    });
  }

  getPredictionModelTechnicalDoc(filename: string) {
    this.customRawMaterialServiceClient.getPredictionModelTechnicalDoc(filename).subscribe((data: HttpResponse<any>) => {
      this.manageSuccess(data);
    }, err => {
      this.manageError(err, filename);
    });
  }


  private manageSuccess(data: HttpResponse<any>) {
    const content = data.headers.get('content-disposition');
    const name = /filename="(.+)"/.exec(content)[1];
    const blob = new Blob([data.body]); // , {type: 'application/pdf'});
    saveAs(blob, name);
  }

  private manageError(err: any, filename: string) {
    const error = err as HttpErrorResponse;
    if (error.status === 404) {
      // nothing to do document don't exist
      this.toastService.toast(this.translationService.instant('msg.common.technical-doc.not-exist'));
      return;
    }
    const message = this.translationService.instant('error.common.technical-doc');
    this.neqDialogService.showErrorDetail(err, message);
    console.log(filename);
  }
}
